
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iit-documentation",
      function () {
        return require("private-next-pages/iit-documentation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iit-documentation"])
      });
    }
  